import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { connect } from 'react-redux'
import { ratingsActions, messageActions } from '../../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Rating from '../../../components/Rating'
import { readOnly } from '../../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  },
  gridInfo: {
    marginBottom: '14px'
  },
  labelSpacing: {
    marginTop: theme.spacing.unit
  },
  link: {
    color: '#002d72'
  }
})

class EditModal extends Component {
  handleSave = rating => {
    const { onClose, editRating, changeMessage } = this.props

    editRating(rating).then(res => {
      changeMessage({ message: 'Alteração realizada com sucesso.' })
      onClose()
    })
  }

  handleSubmit = (e, rating) => {
    e.preventDefault()
    const { setRatingFormTouched } = this.props

    if (this.props.ratingFormErrors.valid) {
      this.handleSave(rating)
    } else {
      setRatingFormTouched()
    }

    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      rating,
      handleChangeRating,
      loadingRating,
      ratingFormErrors,
      formTouched,
      statuses,
      token,
      contentName
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('avaliacoes', token)

    return (
      <div>
        <Dialog
          modalId="avaliacoes-detalhes"
          modalParams={{ registro: rating._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingRating ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id="avaliacoes-detalhes-title">Avaliações — Detalhes da avaliação</DialogTitle>
              <DialogContent>
                <Grid container spacing={0}>
                  <Grid item xs>
                    <Typography variant="body2">ID Usuário</Typography>
                    <Typography variant="body1">{rating.idUsuario || '--'}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={0} className={classes.gridInfo}>
                  <Grid item md={6}>
                    <Typography variant="body2">Nome</Typography>
                    <Typography variant="body1">{rating.nomeUsuario || '--'}</Typography>
                  </Grid>
                  <Grid item md={6}>
                    <Typography variant="body2">E-mail</Typography>
                    <Typography variant="body1">{rating.emailUsuario || '--'}</Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={0} className={classes.gridInfo}>
                  <Grid item md={12}>
                    <Typography variant="body2">Conteúdo</Typography>
                    <Typography variant="body1">
                      <a
                        href={`/conteudos/${rating.conteudo}`}
                        className={classes.link}
                        target="_blank"
                        title={contentName}
                        rel="noopener"
                      >
                        {contentName}
                      </a>
                    </Typography>
                  </Grid>
                  <Grid item md={12} className={classes.labelSpacing}>
                    <Typography variant="body2">Nota</Typography>
                    <Typography variant="body1">
                      <Rating value={rating.nota} />
                    </Typography>
                  </Grid>
                  <Grid item md={12} className={classes.labelSpacing}>
                    <Typography variant="body2">Comentário</Typography>
                    <Typography variant="body1">
                      {rating.comentario || 'Nenhum comentário'}
                    </Typography>
                  </Grid>
                </Grid>

                <form
                  id={'rating-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, rating)
                  }}
                >
                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Status</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={
                        !((ratingFormErrors.fields || {})['status'] || {}).valid && formTouched
                      }
                      onChange={e => {
                        clearErrors()
                        handleChangeRating({
                          ...rating,
                          status: e.target.value
                        })
                      }}
                      value={rating.status || 'Nova'}
                    >
                      {(statuses || []).map(status => {
                        return (
                          <MenuItem key={status} value={status}>
                            {status}
                          </MenuItem>
                        )
                      })}
                    </Select>
                    {!((ratingFormErrors.fields || {})['status'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((ratingFormErrors.fields || {})['status'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  <FormControl
                    error={
                      !((ratingFormErrors.fields || {})['observacao'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-observacao">Observação</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      multiline
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeRating({
                          ...rating,
                          observacao: e.target.value
                        })
                      }}
                      value={rating.observacao}
                      id="field-observacao"
                    />
                    {!((ratingFormErrors.fields || {})['observacao'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((ratingFormErrors.fields || {})['observacao'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'rating-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    rating: state.ratings.rating,
    loadingRating: state.ratings.loadingRating,
    ratingFormErrors: state.ratings.ratingFormErrors,
    formTouched: state.ratings.ratingFormTouched,
    statuses: state.ratings.statuses,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(ratingsActions.openModal())
    },
    closeModal: () => {
      dispatch(ratingsActions.closeModal())
    },
    handleChangeRating: rating => {
      dispatch(ratingsActions.handleChangeRating(rating))
    },
    editRating: rating => {
      return dispatch(ratingsActions.editRating(rating))
    },
    setRatingFormTouched: rating => {
      dispatch(ratingsActions.setRatingFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchRatings: ({ page, perPage }) => {
      dispatch(ratingsActions.fetchRatings({ page, perPage }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Ratings/RatingDetails/EditModal.js